import { internalApi } from "@circle-react/helpers/urlHelpers";
import { useQuery } from "react-query";

interface LiveStreamsConfig {
  feature_flag: string;
  value: string;
}

export const useLiveStreamsConfig = ({ enabled } = { enabled: true }) => {
  const { data: configArray, isInitialLoading } = useQuery<
    LiveStreamsConfig[],
    Error
  >({
    queryKey: [internalApi.liveStreams.configurations()],
    enabled,
  });
  const config: Record<string, string> = {};
  configArray?.forEach(configObj => {
    config[configObj.feature_flag] = configObj.value;
  });

  return {
    isLoading: isInitialLoading,
    config,
  };
};
